module.exports = __webpack_public_path__ + "img/CAN.00cf70a5.svg";